<template>
  <el-table
    v-show="visible && !loading"
    element-loading-text="加载中……"
    stripe
    show-summary
    height="100%"
    ref="reportList"
    :data="tableData"
  >
    <el-table-column
      align="center"
      v-for="(col, idx) in cols.static"
      :key="`top-${idx}`"
      :label="col.label"
      :prop="col.prop"
      :width="col.width"
    >
    </el-table-column>

    <el-table-column
      header-align="center"
      align="center"
      :label="cols.values.label"
    >
      <el-table-column
        header-align="center"
        align="center"
        v-for="(child, idx) in cols.values.children"
        :key="`sub-${idx}`"
        :label="child.label"
        :prop="child.prop"
      >
        <template slot-scope="prop">
          {{
            !showZero && prop.row[child.prop] === 0 ? '' : prop.row[child.prop]
          }}
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default() {
        return []
      }
    },
    groupType: String,
    actived: Number,
    showZero: Boolean
  },
  computed: {
    cates() {
      return this.$store.getters.categories
    },
    cols() {
      const isEmpty = !(this.data && this.data[0])
      if (isEmpty) return { static: [], values: {} }

      if (this.groupType === 'insect') {
        const devs = this.data[0].devices
        return {
          static: [
            { label: '日期', prop: 'date', width: '100px' },
            { label: '种类', prop: 'insect', width: '160px' }
          ],
          values: {
            label: '设备',
            children: devs.map(d => ({ label: d.name, prop: `value-${d.id}` }))
          }
        }
      } else {
        return {
          static: [
            { label: '日期', prop: 'date', width: '100px' },
            { label: '设备', prop: 'device', width: '160px' }
          ],
          values: {
            label: '种类',
            children: this.cates.map(c => ({
              label: c.name,
              prop: `value-${c.name}`
            }))
          }
        }
      }
    },
    tableData() {
      const isEmpty = !(this.data && this.data[0])
      if (isEmpty) return []

      if (this.groupType === 'device') {
        let data = []
        this.data.map(r => {
          const { date, devices = [] } = r
          const dev = devices[this.actived]
          let cols = {}
          dev.categories.forEach(c => {
            cols[`value-${c.name}`] = c.qty
          })

          data.push({ date, device: dev.name, ...cols })
        })
        return data
      } else {
        let data = []
        this.data.map(r => {
          let col = {}
          const { date, devices = [] } = r
          devices.forEach(d => {
            const insect = this.categories[this.actived]
            const cate = d.categories.find(o => o.name === insect.name)
            col[`value-${d.id}`] = cate.qty || 0
            col.insect = insect.name
          })

          data.push({ date, ...col })
        })
        return data
      }
    }
  },
  methods: {},
  watch: {
    cols() {
      this.$refs.reportList && this.$refs.reportList.doLayout()
    }
  }
}
</script>

<style lang="css" scoped></style>
